import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  BulkRemoveAssignmentInput,
  MutationBulkRemoveFlexibleBenefitsResponse,
  BulkRemoveAssignmentInputVariable,
} from '../types';

const removeBulkFlexibleComponentsAssignmentsMutation = gql`
  mutation RemoveBulkFlexibleAssignments($input: BulkRemoveAssignmentInput!) {
    payrollBulkRemoveAssignments(input: $input) {
      results {
        status
      }
      code
      success
      message
    }
  }
`;

export const removeBulkFlexibleComponentsAssignments = (
  input: BulkRemoveAssignmentInputVariable,
) => {
  return graphQLApi<MutationBulkRemoveFlexibleBenefitsResponse, BulkRemoveAssignmentInput>({
    query: removeBulkFlexibleComponentsAssignmentsMutation,
    queryVariables: { input },
  });
};
